import {
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import React from 'react';
import {
  PiBoatThin,
  PiCircleThin,
  PiDiamondThin,
  PiRadio,
  PiWaveSquare,
  PiDrone,
} from 'react-icons/pi';
import { cn } from '@ais-ui/utils';
import { TbTemperature } from 'react-icons/tb';
import { GhVirtualAton } from '../../../assets/icons/GhVirtualAton';
import { TargetCardTargetType } from './useTargetForm';

interface TabButtonProps {
  icon: React.ElementType;
  value: string;
  onClick: (value: TargetCardTargetType) => void;
  tooltipText: string;
}

interface TargetCardSettingsTabsProps {
  setTab: React.Dispatch<React.SetStateAction<TargetCardTargetType>>;
  tab: TargetCardTargetType;
}

const TabButton = ({
  icon: Icon,
  value,
  onClick,
  tooltipText,
}: TabButtonProps) => {
  return (
    <Tooltip>
      <TabsTrigger asChild value={value}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className={cn('justify-center')}
            onClick={() => onClick(value as TargetCardTargetType)}
          >
            <Icon className={cn('size-6', 'group-hover/btn:text-primary')} />
          </Button>
        </TooltipTrigger>
      </TabsTrigger>
      <TooltipContent className="ml-4">{tooltipText}</TooltipContent>
    </Tooltip>
  );
};

export const TargetCardSettingsTabs = ({
  tab,
  setTab,
}: TargetCardSettingsTabsProps) => {
  const onClick = (value: TargetCardTargetType) => {
    setTab(value);
  };

  return (
    <Tabs value={tab} className="px-6 pb-6 pt-2">
      <TabsList>
        <TabButton
          icon={PiBoatThin}
          value="vessel"
          onClick={onClick}
          tooltipText="Vessel"
        />
        <TabButton
          icon={PiDiamondThin}
          value="aton"
          onClick={onClick}
          tooltipText="AtoN"
        />
        <TabButton
          icon={GhVirtualAton}
          value="virtualAton"
          onClick={onClick}
          tooltipText="Virtual AtoN"
        />
        <TabButton
          icon={TbTemperature}
          value="methyd"
          onClick={onClick}
          tooltipText="Met/Hyd"
        />
        <TabButton
          icon={PiCircleThin}
          value="baseStation"
          onClick={onClick}
          tooltipText="Base Station"
        />
        <TabButton
          icon={PiRadio}
          value="radar"
          onClick={onClick}
          tooltipText="Radar"
        />
        <TabButton
          icon={PiWaveSquare}
          value="das"
          onClick={onClick}
          tooltipText="DAS"
        />
        <TabButton
          icon={PiDrone}
          value="drone"
          onClick={onClick}
          tooltipText="Drone"
        />
      </TabsList>
    </Tabs>
  );
};
